export default __webpack_public_path__ + "static/media/latam-color.518fba7f.svg";